/**
 * Create Resouce Item from data.
 */

export default class ResourceItem {
	constructor(data) {
		this.data = data;
	}

	html() {
		let target = '_self';

		if ((this.data.file_type.length) && this.data.file_type !== 'video') {
			target = '_blank';
		}

		let html = `
			<div class="resource-item hide fade-in">
			<a href="${this.data.link}" class="resource-item__wrapper" target="${target}" data-id="${this.data.ID}">
					<div class="resource-item__content">
						<div class="resource-item__image" data-asset-type="${this.data.asset_type}">${this.data.thumbnail}</div>
						<div class="resource-item__descriptive-content">
							<span class="resource-item__term">${this.data.term_label}</span>
							<span class="resource-item__title">${this.data.post_title}</span>
							<span class="resource-item__author">${this.data.author}</span>
							<span class="resource-item__date">${this.data.date}</span>
						</div>
					</div>
				</a>
			`;

		if (this.data.download_options.add_download_options) {
			const parameter = encodeURIComponent(this.data.post_title.toLowerCase());
			html += `
				<div class="resource-item__download-options">
					<a href="${this.data.link}" target="${target}">Download</a>
					<span></span>
					<a href="${this.data.download_options.brochure_link}?brochure=${parameter}">Request Hard Copy</a>
				</div>`;
		}

		html += '</div>'; // closing .resource-item tag.

		return html;
	}
}
